import { type ReactNode, useRef, useEffect, useState } from 'react';

type Props = { children: ReactNode; deps: string };

export function AnimateHeight({ children, deps }: Props): ReactNode {
  const ref = useRef<HTMLDivElement>(null);
  const [h, setH] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!ref.current) return;
    setH(ref.current.scrollHeight);
  }, [deps]);

  return (
    <div
      className="overflow-hidden transition-[height] duration-200 ease-out"
      style={{ height: h !== undefined ? h : 'auto' }}
    >
      <div ref={ref}>{children}</div>
    </div>
  );
}
